module.exports = __webpack_public_path__ + "img/4豪华套房.81ab405.jpg";